import { render, staticRenderFns } from "./AreaMapPref.vue?vue&type=template&id=0a95a57c&scoped=true&"
import script from "./AreaMapPref.vue?vue&type=script&lang=js&"
export * from "./AreaMapPref.vue?vue&type=script&lang=js&"
import style0 from "./AreaMapPref.vue?vue&type=style&index=0&id=0a95a57c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a95a57c",
  null
  
)

export default component.exports